import React from 'react';
import './heroStyle.css';
import HeroContainer from '../../ui/hero-container';
import { useNavigate } from 'react-router-dom';
import Button from '../../ui/button/Button';
import ButtonOutline from '../../ui/button/ButtonOutline';
const AboutHeroSection = () => {
  const navigate = useNavigate();
  return (
    <>
      <HeroContainer className="landing-section !pb-[212px] !pt-8 md:!pb-[259px]">
        <p className="tagline ">I AM Always improving 🚀</p>
        <h1 className="hero-title fredokaOne relative mb-[30px] max-w-[836px] text-center">
          Empowering tomorrow&apos;s leaders through personalized, tech-driven education
          <p className="emoji-pos-robot">
            <img src="/images/about/robot.png" alt="" />
          </p>
          <p className="emoji-pos-rocket">
            <img src="/images/about/rocket.png" alt="" />
          </p>
          <p className="emoji-pos-laptop">
            <img src="/images/about/laptop.png" alt="" />
          </p>
          <p className="emoji-pos-book">
            <img src="/images/about/book.png" alt="" />
          </p>
        </h1>
        <p className="fredoka max-w-[770px] text-center text-[19px] font-medium leading-[32px] tracking-[-0.22px] text-[#678285]  md:text-[22px]">
          Equipping Educators to Transform Tutoring Through Advanced AI-Driven Tools
        </p>
        <div className="mt-6 flex w-full flex-col-reverse justify-center gap-4 md:flex-row">
          <Button className="text-base md:!w-fit" onClick={() => {}} label={'Start Free Trial'} />
          <ButtonOutline
            className="md:!w-fit"
            onClick={() => {
              navigate('/waitlist');
            }}
            label={'Join our waitlist'}
          />
        </div>
      </HeroContainer>
      <div className="about-hero-img">
        <img className="about-hero-img-1" src="/images/about/about-hero-img.png" alt="" />
        <img className="about-hero-img-2" src="/images/about/about-hero-mobile-img.png" alt="" />
      </div>
    </>
  );
};

export default AboutHeroSection;
